export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      UserIdentity: 'member002',
      ClientFlg: false,
      MentorFlg: true,
      ProMentorFlg: false,
      MentorInfo: {
        UserName: 'メンター太郎',
        Sex: 1,
        Birthday: '1980/10/22',
        RegionCd: 4,
        MailAddress: 'aaa@aaa.com',
        SoudanCount: 8,
        ComplaintCount: 12,
        NgWordUseCount: 10,
        UserState: 1,
        EntryDt: '2020/10/03 17:20:36',
        DeleteDt: '2020/10/03 17:20:36',
        LastLoginDt: '2020/10/03 17:20:36',
        MentorProfile: 'プロフィールテキスト'
      },
      AdminMemo: 'xxxxxxxxxxx'
    }
  }
}